module.exports = __webpack_public_path__ + "static/media/ReportLogo.3b7ab90c.png";